<script setup lang="ts">
import {HomeSellinItem} from "@/home/interfaces";
import HomeLiveItem from "@/home/components/HomeLiveItem.vue";
import Icon from "@/core/components/icon/Icon.vue";
import {useRouter} from "vue-router";
import imagesHelper from "@/core/helpers/imagesHelper";

const {item} = defineProps<{
    item: HomeSellinItem['data']
}>();
const router = useRouter();

const onItemPress = () => {
    router.push({name: 'disruption-logistics.disruption-alerts.detail', params: {offerId: item.id}});
};
</script>

<template>
  <HomeLiveItem
    :at="item.created_at ?? 'Date non disponible'"
    @click="onItemPress"
  >
    <template #image>
      <div v-if="item.image_path" class="bg-white rounded-lg shadow-md overflow-hidden h-full w-full">
        <img
          :src="imagesHelper.getURLFromPath('images/' + item.image_path)"
          class="w-full h-full object-cover"
          alt="logo"
        >
      </div>
      <Icon v-else name="mdi-truck" :size="50" color="primary" />
    </template>
    <strong>{{ item.name }}</strong>
    <p>Offre de dépannage</p>
  </HomeLiveItem>
</template>
